function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbacus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 63,
    width: 67,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M361.931,61.793h-35.31c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828S366.813,61.793,361.931,61.793"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M291.31,61.793H256c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828S296.192,61.793,291.31,61.793"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M220.69,61.793h-52.966c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h52.966 c4.882,0,8.828,3.955,8.828,8.828S225.571,61.793,220.69,61.793"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M308.966,406.069h-70.621c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828 h70.621c4.882,0,8.828,3.955,8.828,8.828C317.793,402.114,313.847,406.069,308.966,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M203.034,406.069h-52.966c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828 h52.966c4.882,0,8.828,3.955,8.828,8.828C211.862,402.114,207.916,406.069,203.034,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M379.586,406.069h-44.138c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828 h44.138c4.882,0,8.828,3.955,8.828,8.828C388.414,402.114,384.468,406.069,379.586,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M176.552,176.552h-35.31c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828S181.433,176.552,176.552,176.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M247.172,176.552h-35.31c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828S252.054,176.552,247.172,176.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M317.793,176.552h-35.31c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828S322.675,176.552,317.793,176.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M370.759,291.31h-35.31c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828C379.586,287.356,375.64,291.31,370.759,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M300.138,291.31h-35.31c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828C308.966,287.356,305.02,291.31,300.138,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M229.517,291.31h-35.31c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828C238.345,287.356,234.399,291.31,229.517,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M441.379,61.793h-44.138c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h44.138 c4.882,0,8.828,3.955,8.828,8.828S446.261,61.793,441.379,61.793"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M132.414,61.793H70.621c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h61.793 c4.882,0,8.828,3.955,8.828,8.828S137.295,61.793,132.414,61.793"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M441.379,406.069h-35.31c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h35.31 c4.882,0,8.828,3.955,8.828,8.828C450.207,402.114,446.261,406.069,441.379,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M114.759,406.069H70.621c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h44.138 c4.882,0,8.828,3.955,8.828,8.828C123.586,402.114,119.64,406.069,114.759,406.069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M450.207,176.552h-97.103c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h97.103 c4.882,0,8.828,3.955,8.828,8.828S455.089,176.552,450.207,176.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M450.207,291.31h-44.138c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h44.138 c4.882,0,8.828,3.955,8.828,8.828C459.034,287.356,455.089,291.31,450.207,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M158.897,291.31H61.793c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h97.103 c4.882,0,8.828,3.955,8.828,8.828C167.724,287.356,163.778,291.31,158.897,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M105.931,176.552H61.793c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h44.138 c4.882,0,8.828,3.955,8.828,8.828S110.813,176.552,105.931,176.552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E2E3"
    },
    d: "M70.621,476.69H35.31V17.655C35.31,7.901,43.211,0,52.966,0s17.655,7.901,17.655,17.655V476.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E2E3"
    },
    d: "M476.69,476.69h-35.31V17.655C441.379,7.901,449.28,0,459.034,0s17.655,7.901,17.655,17.655V476.69 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M105.931,512H0v-17.655c0-9.754,7.901-17.655,17.655-17.655h70.621 c9.754,0,17.655,7.901,17.655,17.655V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M512,512H406.069v-17.655c0-9.754,7.901-17.655,17.655-17.655h70.621 c9.754,0,17.655,7.901,17.655,17.655V512z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M150.069,79.448L150.069,79.448c-9.754,0-17.655-7.901-17.655-17.655V44.138 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C167.724,71.548,159.823,79.448,150.069,79.448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M238.345,79.448L238.345,79.448c-9.754,0-17.655-7.901-17.655-17.655V44.138 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C256,71.548,248.099,79.448,238.345,79.448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M308.966,79.448L308.966,79.448c-9.754,0-17.655-7.901-17.655-17.655V44.138 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C326.621,71.548,318.72,79.448,308.966,79.448"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M379.586,79.448L379.586,79.448c-9.754,0-17.655-7.901-17.655-17.655V44.138 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C397.241,71.548,389.341,79.448,379.586,79.448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M123.586,194.207L123.586,194.207c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C141.241,186.306,133.341,194.207,123.586,194.207"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M194.207,194.207L194.207,194.207c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C211.862,186.306,203.961,194.207,194.207,194.207"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M264.828,194.207L264.828,194.207c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C282.483,186.306,274.582,194.207,264.828,194.207"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M335.448,194.207L335.448,194.207c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C353.103,186.306,345.203,194.207,335.448,194.207"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M317.793,308.966L317.793,308.966c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C335.448,301.065,327.548,308.966,317.793,308.966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M247.172,308.966L247.172,308.966c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C264.828,301.065,256.927,308.966,247.172,308.966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M176.552,308.966L176.552,308.966c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C194.207,301.065,186.306,308.966,176.552,308.966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M388.414,308.966L388.414,308.966c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C406.069,301.065,398.168,308.966,388.414,308.966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M388.414,423.724L388.414,423.724c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655s17.655,7.901,17.655,17.655v17.655C406.069,415.823,398.168,423.724,388.414,423.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M317.793,423.724L317.793,423.724c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C335.448,415.823,327.548,423.724,317.793,423.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M220.69,423.724L220.69,423.724c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C238.345,415.823,230.444,423.724,220.69,423.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M132.414,423.724L132.414,423.724c-9.754,0-17.655-7.901-17.655-17.655v-17.655 c0-9.754,7.901-17.655,17.655-17.655c9.754,0,17.655,7.901,17.655,17.655v17.655C150.069,415.823,142.168,423.724,132.414,423.724"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbacus);
export default __webpack_public_path__ + "static/media/abacus.ace9fe82aef020d31a1f77ead77b4fc5.svg";
export { ForwardRef as ReactComponent };